import { createSelector } from 'reselect';
import { ACCOUNTS_VALUE_CHANGES_REDUCER_KEY } from './accountsValueChangesTypes';

export const getStore = (state) => state[ACCOUNTS_VALUE_CHANGES_REDUCER_KEY];

export const getLoadPending = (state) => getStore(state).loadPending;
export const getIsLoading = (state) => getStore(state).isLoading;
export const getError = (state) => getStore(state).error;
export const getRows = (state) => getStore(state).rows;
export const getColumns = (state) => getStore(state).columns;

export const addHeaderNametoCellData = createSelector(getRows, getColumns, (valueRows, valueColumns) => {
  valueRows?.forEach((row) => {
    row?.cellData?.forEach((cell, index) => {
      const columnValue = valueColumns?.[index];
      columnValue?.headerName ? (cell.headerName = columnValue.headerName) : null;
    });
  });
  return valueRows;
});

export const getDailyValueChanges = createSelector(addHeaderNametoCellData, (modifiedData) => modifiedData);

export const getTotalBalanceCell = createSelector(
  getRows,
  (rows) => rows.find((item) => item.name === 'Total')?.cellData?.[0]?.value,
);
